import { ref as n, onBeforeUnmount as _, resolveComponent as B, openBlock as C, createBlock as g } from "vue";
import E from "./design-system.es9.js";
import L from "./design-system.es11.js";
import w from "./design-system.es116.js";
import x from "./design-system.es128.js";
const b = () => {
}, A = {
  name: "DsErrorBannerContainer",
  components: { ErrorBanner: E },
  setup() {
    const c = n(!1), s = n(), t = n(), o = n(!1), i = n(!1), m = n(), r = n(), f = n(b), { emitter: l } = L(), v = w();
    function u(e) {
      const h = document.body.className.indexOf("overlay-active") >= 0;
      c.value = !0, s.value = e.bottom || h ? "bottom" : "top", t.value = e.message, o.value = e.showIcon, i.value = e.critical, m.value = e.actionText || e.actionLabel, r.value = e.closeLabel || v.messages["errorbanner.dismiss"], f.value = e.action || b;
    }
    function a() {
      c.value = !1;
    }
    function d() {
      a();
    }
    function p() {
      f.value(), a();
    }
    return l.on("open", u), l.on("close", a), _(() => {
      l.off("open", u), l.off("close", a);
    }), {
      isOpen: c,
      position: s,
      message: t,
      showIcon: o,
      critical: i,
      actionLabel: m,
      closeLabel: r,
      action: f,
      handleClose: d,
      handleAction: p,
      close: a
    };
  }
};
function O(c, s, t, o, i, m) {
  const r = B("ErrorBanner");
  return C(), g(r, {
    "is-open": o.isOpen,
    position: o.position,
    message: o.message,
    "show-icon": o.showIcon,
    critical: o.critical,
    "action-label": o.actionLabel,
    "close-label": o.closeLabel,
    onClose: o.handleClose,
    onAction: o.handleAction
  }, null, 8, ["is-open", "position", "message", "show-icon", "critical", "action-label", "close-label", "onClose", "onAction"]);
}
const N = /* @__PURE__ */ x(A, [["render", O]]);
export {
  N as default
};
//# sourceMappingURL=design-system.es10.js.map
